const grey = {
  50: "#f7f7f8",
  100: "#ebebef",
  200: "#d8d8df",
  300: "#b9b9c6",
  400: "#8f8fa3",
  500: "#73738c",
  600: "#5a5a72",
  700: "#434356",
  800: "#25252d",
  900: "#131318",
  A100: "#f7f7f8",
  A200: "#ebebef",
  A400: "#8f8fa3",
  A700: "#434356",
};

export default grey;
